<template slot-scope="scope">
  <!-- 订单管理 服务商  需求订单 -->
  <div class="device-list">
    <div class="device-list-tab">
      <el-table
        :data="tableData"
        style="width: 100%"
        :row-class-name="tableRowClassName"
        :header-cell-style="{
          background: '#409eff ',
          textAlign: 'center',
          color: '#ffffff',
          padding: '3px',
          fontSize: '12px',
          fontWeight: '400',
          height: '45px',
        }"
        :row-style="{ height: '35px' }"
      >
        <el-table-column label="订单ID" align="center" show-overflow-tooltip>
          <template slot-scope="scope">
            {{ scope.row.orderNumber }}
          </template>
        </el-table-column>
        <el-table-column label="服务名称" align="center" show-overflow-tooltip>
          <template slot-scope="scope">
            {{
              Math.sign(scope.row.consumption) == 1
                ? "+" + scope.row.consumption
                : scope.row.consumption
            }}
          </template>
        </el-table-column>
        <el-table-column
          label="服务价格(元)"
          align="center"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <!-- 判断正负数 -->
            {{
              Math.sign(scope.row.traceCoin) == 1
                ? "+" + scope.row.traceCoin
                : scope.row.traceCoin
            }}
          </template>
        </el-table-column>
        <el-table-column label="服务数量" align="center" show-overflow-tooltip>
          <template slot-scope="scope">
            {{ scope.row.typeName }}
          </template>
        </el-table-column>
        <el-table-column label="服务对象" align="center" show-overflow-tooltip>
          <template slot-scope="scope">
            {{ scope.row.payMethodName }}
          </template>
        </el-table-column>

        <el-table-column label="服务标签" align="center" show-overflow-tooltip>
          <template slot-scope="scope">
            {{ scope.row.payMethodName }}
          </template>
        </el-table-column>
        <el-table-column label="订单状态" align="center" show-overflow-tooltip>
          <template slot-scope="scope">
            <span
              :style="
                scope.row.status == 0
                  ? 'color: #FFA200;'
                  : scope.row.status == 1
                  ? 'color: #3BB500;'
                  : ''
              "
            >
              {{
                scope.row.status == 0
                  ? "发送合同中"
                  : scope.row.status == 1
                  ? "签订合同中"
                  : ""
              }}
            </span>
          </template>
        </el-table-column>
        <el-table-column label="服务时间" align="center" show-overflow-tooltip>
          <template slot-scope="scope">
            {{ scope.row.createTime }}
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" width="180">
          <template slot-scope="scope">
            <!-- scope.row.sort == 0 服务商操作 -->
            <div class="table-p" v-if="scope.row.sort == 0">
              <span
                @click="handelSendContract(scope.$index, scope.row)"
                v-if="scope.row.status == 0"
                >发送合同</span
              >
              <span v-if="scope.row.status == 1">——</span>
              <span v-if="scope.row.status == 2">缴纳</span>
            </div>
            <!-- scope.row.sort == 1  需求方操作 -->
            <div class="table-p" v-if="scope.row.sort == 1">
              <span v-if="scope.row.status == 0">——</span>
              <span
                v-if="scope.row.status == 1"
                @click="handelSignContract(scope.$index, scope.row)"
                >签订合同</span
              >
              <span v-if="scope.row.status == 1">取消</span>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    tableData: {},
  },
  components: {},
  data() {
    return {};
  },
  computed: {},
  created() {},
  methods: {
    // 发送合同
    handelSendContract(index, row) {
      // 点击发送合同跳转 合同信息编辑页面
      this.$router.push({
        path: "/HelpShop/QuasiContract",
      });
    },
    // 签订合同
    handelSignContract(index, row) {
      this.$router.push({
        path: "/HelpShop/SignContract",
      });
    },
    //表格颜色
    tableRowClassName({ row, rowIndex }) {
      if (rowIndex % 2 == 0) {
        return "warning-row";
      } else if (rowIndex % 2 == 1) {
        return "success-row";
      }
      return "success-row";
    },
  },
};
</script>

<style scoped lang="less">
.table-p {
  color: #409eff ;
  span:nth-child(1) {
    margin-left: 0px;
  }
  span {
    margin-left: 10px;
  }
}
/deep/th:nth-child(1) {
  border-radius: 10px 0 0 0 !important;
}
/deep/th:nth-child(9) {
  border-radius: 0px 10px 0px 0px !important;
}
// /deep/th:nth-last-child(1) {
//   border-radius: 0 10px 0 0 !important;
// }
.device-list-tab {
  border: 1px solid #eeeeee;
  border-radius: 10px 10px 0 0;
}
/deep/th {
  height: 45px !important;
  padding: 0;
}
/deep/ td {
  height: 40px !important;
  padding: 0;
}
/deep/.el-table__empty-block,
/deep/.el-table tr,
/deep/.el-table--striped .el-table__body tr.el-table__row--striped td {
  color: #333333;
  font-weight: 400;
  font-size: 12px;
}
/deep/.el-table .warning-row td {
  font-size: 12px;
  color: #333333;
}

::v-deep .el-table .warning-row td {
  background: #eeeeee !important;
}
/deep/.device-list {
  border: 1px solid goldenrod !important;
}
</style>
